import { render, staticRenderFns } from "./ChangeCustomerManagerModal.vue?vue&type=template&id=708a139a&"
import script from "./ChangeCustomerManagerModal.vue?vue&type=script&lang=js&"
export * from "./ChangeCustomerManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports